"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TitleImage;
const react_1 = __importDefault(require("react"));
const context_1 = __importDefault(require("./context"));
const classnames_1 = __importDefault(require("classnames"));
function TitleImage() {
    const { reverseGradient, title, titleImageUrl } = (0, context_1.default)();
    // const titleLogo = ''; // For future use
    if (!title || !titleImageUrl) {
        return null;
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('hero', { 'reverse-gradient': reverseGradient }) },
        react_1.default.createElement("div", { className: 'content book-title' },
            react_1.default.createElement("h1", { className: 'image-heading' },
                react_1.default.createElement("img", { className: 'title-image', src: titleImageUrl, alt: title, height: '130', width: '392' })))));
}
